import React from 'react'
import { Skeleton } from '@material-ui/lab'

const LoaderPoll = () => {
  let count = 0
  return (
    <div className="space-y-10">
      <Skeleton animation="wave" variant="text" className="h-32" />

      {[...Array(3)].map(() => (
        <div key={`loader-${count++}`} className="flex space-x-5 items-center">
          <div className="w-5/6">
            <Skeleton animation="wave" variant="text" />
          </div>

          <Skeleton
            animation="wave"
            variant="rect"
            className="rounded-8"
            width={40}
            height={40}
          />

          <Skeleton animation="wave" variant="circle" className="w-20 h-20" />
        </div>
      ))}
    </div>
  )
}

export default LoaderPoll
